
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters([
      'isLoggedIn',
      'emailVerified',
      'isAdmin',
      'isGraduate',
      'isIndustry',
      'allSchools',
      'graduateSchools',
      'regions',
      'schoolById',
    ]),
  },
  props: ['school'],
  data: () => ({
    show: false,
    loading: false,
    selection: null,
  }),

  methods: {},
}
